import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Image } from '@/components/client';
interface PointMarketListItemProps {
  thumbnailUrl?: string;
  productName?: string;
  size?: 'small' | 'large';
  price?: number;
}
export const PointMarketListItem = t0 => {
  const $ = _c(21);
  const {
    thumbnailUrl,
    productName,
    price,
    size: t1
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  const t2 = productName || "\uC0C1\uD488 \uC774\uBBF8\uC9C0";
  let t3;
  if ($[0] !== t2 || $[1] !== thumbnailUrl) {
    t3 = <div className="relative size-72 overflow-hidden rounded-medium border border-Gray-200"><Image src={thumbnailUrl} className="size-full object-cover" alt={t2} width={144} height={144} /></div>;
    $[0] = t2;
    $[1] = thumbnailUrl;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = size === "small" && "font-400";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("line-clamp-2 font-500 typo-body3", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== productName || $[6] !== t5) {
    t6 = <h3 className={t5}>{productName}</h3>;
    $[5] = productName;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== size) {
    t7 = cn("font-700 typo-body2", {
      small: "typo-body3",
      large: "typo-body2"
    }[size]);
    $[8] = size;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== price) {
    t8 = price?.toLocaleString();
    $[10] = price;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <p className={t7}>{t8}P</p>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <div className="flex h-72 flex-col justify-center">{t6}{t9}</div>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3) {
    t11 = <article className="flex items-center gap-12">{t3}{t10}</article>;
    $[18] = t10;
    $[19] = t3;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};